module.exports = __webpack_public_path__ + "static/img/Aiewm2.c700dd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aiewm2.png
// module id = O3u+
// module chunks = 43